import { Container, Grid } from '@mui/material';
import InviteUser from '../../components/UserInfo/InviteUser';

const InviteUserPage = () => {
  return (
    <Container sx={{ padding: '120px 0' }}>
      <Grid
        container
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        sx={{ marginBottom: '2em' }}
        gap={4}
      >
        <InviteUser />
      </Grid>
    </Container>
  );
};

export default InviteUserPage;
